<!-- banner -->
<template>
  <div>
    <div class="banner-wrapper">
      <img src="../assets/banner.jpg" alt="">
    </div>
    <div class="banner">
      <div class="line-wrapper">
        <div class="police-line"></div>
        <div class="police-line-2"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}

</script>
<style lang='scss' rel='stylesheet/scss' scoped>
$thema:#F1D147;
.banner-wrapper{
  position:absolute;
  top:0;
  left:0;
  width:100vw;
  height:100vh;
  z-index: 2;
  text-align: center;
  box-sizing: border-box;
  display:flex;
  align-items:center;
  justify-content: center;
  padding-top:80px;
  overflow: hidden;
  background-color: #EEEBE6;
  // div {
  //   width: 100%;
  //   box-shadow:0px 0px 20px 10px red;
    img{
      width:100%;
    }
  // }
}
.banner{
  width:100vw;
  height:100vh;
  overflow: hidden;
  position:relative;
  .line-wrapper{
    position:absolute;
    top:0;
    left:0;
    width:100vw;
    height:100vh;
    transform: rotate(3.5deg);
    z-index: 998;
    .police-line{
      position: absolute;
      bottom: 24%;
      left: -20px;
      width:200%;
      height:50px;
      background-color: $thema;
      background-image: linear-gradient(to bottom right, black 25%, transparent 25%, transparent 50%, black 50%, black 75%, transparent 75%, transparent 100%);
      background-size: 40px 40px;
      animation:move 5s infinite linear;
    }
    .police-line-2{
      position:absolute;
      right:30px;
      top:-20px;
      background-color: $thema;
      background-image: linear-gradient(to bottom right, black 25%, transparent 25%, transparent 50%, black 50%, black 75%, transparent 75%, transparent 100%);
      background-size: 40px 40px;
      animation:scroll 5s infinite linear;
      width:50px;
      height: 200%;
    }
  }
}
@keyframes scroll {
  0%{
    webkit-transform: translate3d(0,0,0);
    -moz-transform: translate3d(0,0,0);
    -ms-transform: translate3d(0,0,0);
    -o-transform: translate3d(0,0,0);
    transform: translate3d(0,0,0);
  }
  100%{
    webkit-transform: translate3d(0,-15%,0);
    -moz-transform: translate3d(0,-15%,0);
    -ms-transform: translate3d(0,-15%,0);
    -o-transform: translate3d(0,-15%,0);
    transform: translate3d(0,-15%,0);
  }
}
@keyframes move {
  0%{
    webkit-transform: translate3d(0,0,0);
    -moz-transform: translate3d(0,0,0);
    -ms-transform: translate3d(0,0,0);
    -o-transform: translate3d(0,0,0);
    transform: translate3d(0,0,0);
  }
  100%{
    webkit-transform: translate3d(-15%,0,0);
    -moz-transform: translate3d(-15%,0,0);
    -ms-transform: translate3d(-15%,0,0);
    -o-transform: translate3d(-15%,0,0);
    transform: translate3d(-15%,0,0);
  }
}
</style>